import script from "./DeviceConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceConfig.vue?vue&type=script&setup=true&lang=js"

import "./DeviceConfig.vue?vue&type=style&index=0&id=026be42b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026be42b"]])

export default __exports__